import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DescriptionIcon(props: IconProps) {
    return <Icon {...props} iconKey={"description"}/>
}
